// Utility function to get UTM parameters from URL
export const getUTMParameters = () => {
  if (typeof window === 'undefined') return {};
  
  const urlParams = new URLSearchParams(window.location.search);
  
  return {
    source: urlParams.get('utm_source'),
    medium: urlParams.get('utm_medium'),
    campaign: urlParams.get('utm_campaign'),
    term: urlParams.get('utm_term'),
    content: urlParams.get('utm_content')
  };
};

// Check if the visitor should see the contact button
export const shouldShowContactButton = () => {
  const utmParams = getUTMParameters();
  
  // Show button if there's no UTM source or if UTM source is not 'upwork'
  return !utmParams.source || utmParams.source.toLowerCase() !== 'upwork';
};

// Get visitor info for tracking
export const getVisitorInfo = () => {
  const utmParams = getUTMParameters();
  
  return {
    ...utmParams,
    referrer: typeof window !== 'undefined' ? document.referrer : '',
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
    timestamp: new Date().toISOString()
  };
};
